// DIDIT INTEGRATION - COMMENTED OUT
import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();

export const createDiditSessionAPI = (userId, callbackUrl, workflowId = null) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();

        // Підготовка тіла запиту
        const requestBody = {
            callback_url: callbackUrl,
            user_id: userId,
            ...(workflowId && { workflow_id: workflowId }),
            metadata: {
                source: "sugarcribs-frontend",
                timestamp: new Date().toISOString()
            }
        };

        axiosInstance
            .post('/api/didit/verification/session', requestBody, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => {
                if (res.data.success) {
                    // Тепер беремо дані з res.data.verification
                    const data = res.data?.data;

                    // Return session data without opening popup (handled in component)
                    resolve({
                        ...data
                    });
                } else if (res.data.error) {
                    const error = res.data.error;

                    if (error.includes('already has an active verification request')) {
                        const verification = res.data.verification || {};
                        reject({
                            type: 'ACTIVE_VERIFICATION_EXISTS',
                            message: error,
                            verification_id: verification.verification_id,
                            status: verification.status,
                            created_at: verification.created_at,
                            expires_at: verification.expires_at,
                            verification_url: verification.verification_url || null
                        });
                    } else {
                        reject(new Error(error || 'Failed to create session'));
                    }
                } else {
                    reject(new Error('Unexpected backend response format'));
                }
            })
            .catch((err) => {
                // console.error('API call failed:', err);
                reject(err?.response?.data || err);
            });
    });
};


export const getDiditSessionStatusAPI = (sessionId) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();

        // Call your backend endpoint
        axiosInstance
            .get(`/api/didit/session/${sessionId}/status`, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => {
                if (res.data.success) {
                    resolve(res.data.data);
                } else {
                    reject(new Error(res.data.error || 'Failed to get session status'));
                }
            })
            .catch((err) => reject(err?.response?.data || err));
    });
};

export const getDiditVerificationResultsAPI = (userId) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();

        // Call your backend endpoint
        axiosInstance
            .get(`/api/didit/verification-results/${userId}`, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => {
                if (res.data.success) {
                    resolve(res.data.data);
                } else {
                    reject(new Error(res.data.error || 'Failed to get verification results'));
                }
            })
            .catch((err) => reject(err?.response?.data || err));
    });
};

export const checkDiditVerificationStatusAPI = (userId) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();

        // Call your backend endpoint
        axiosInstance
            .get(`/api/didit/verification-status/${userId}`, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => {
                if (res.data.success) {
                    resolve(res.data.data);
                } else {
                    reject(new Error(res.data.error || 'Failed to check verification status'));
                }
            })
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Additional Didit API methods based on documentation
export const retrieveDiditSessionAPI = (sessionId) => {
    return new Promise((resolve, reject) => {
        const url = `https://verification.didit.me/v2/session/${sessionId}`;
        const options = {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Authorization': `Bearer ${process.env.REACT_APP_DIDIT_API_KEY}`
            }
        };

        fetch(url, options)
            .then(res => res.json())
            .then(data => resolve(data))
            .catch(err => reject(err));
    });
};

export const listDiditSessionsAPI = (params = {}) => {
    return new Promise((resolve, reject) => {
        const queryString = new URLSearchParams(params).toString();
        const url = `https://verification.didit.me/v2/sessions${queryString ? `?${queryString}` : ''}`;
        const options = {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Authorization': `Bearer ${process.env.REACT_APP_DIDIT_API_KEY}`
            }
        };

        fetch(url, options)
            .then(res => res.json())
            .then(data => resolve(data))
            .catch(err => reject(err));
    });
};

export const deleteDiditSessionAPI = (sessionId) => {
    return new Promise((resolve, reject) => {
        const url = `https://verification.didit.me/v2/session/${sessionId}`;
        const options = {
            method: 'DELETE',
            headers: {
                'accept': 'application/json',
                'Authorization': `Bearer ${process.env.REACT_APP_DIDIT_API_KEY}`
            }
        };

        fetch(url, options)
            .then(res => res.json())
            .then(data => resolve(data))
            .catch(err => reject(err));
    });
};

export const generateDiditPDFAPI = (sessionId) => {
    return new Promise((resolve, reject) => {
        const url = `https://verification.didit.me/v2/session/${sessionId}/pdf`;
        const options = {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Authorization': `Bearer ${process.env.REACT_APP_DIDIT_API_KEY}`
            }
        };

        fetch(url, options)
            .then(res => res.json())
            .then(data => resolve(data))
            .catch(err => reject(err));
    });
};

export const getDiditVerificationByUserIdAPI = (userId) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();

        // Call your backend endpoint
        axiosInstance
            .get(`/api/didit/verification/user/${userId}`, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => {
                if (res.data.success) {
                    resolve(res.data);
                } else {
                    reject(new Error(res.data.error || 'Failed to get verification status'));
                }
            })
            .catch((err) => reject(err?.response?.data || err));
    });
};

export const deleteVerificationAPI = (sessionId) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();

        axiosInstance
            .delete(`/api/didit/verification/session/${sessionId}`, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]: `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => {
                if (res.data.success) {
                    if (res.data.didit_deleted) {
                        // console.log('✅ Session deleted from both Didit and local DB');
                    } else {
                        // console.log('⚠️ Session deleted from local DB, but Didit deletion failed');
                    }
                    resolve(res.data);
                } else {
                    reject(new Error(res.data.error || 'Failed to delete verification session'));
                }
            })
            .catch((err) => {
                // console.error('Error deleting verification:', err);
                reject(err?.response?.data || err);
            });
    });
};